// =========================
// ROUTER.JS
// =========================

// This file defines a Router class that manages the routing of the application.
import feedView from './views/pages/feed';
import homeView from './views/pages/home';
import fourOFourView from './views/pages/404';
import signinView from './views/pages/signin';
import signupView from './views/pages/signup';
import profileView from './views/pages/profile';
import editProfileView from './views/pages/editProfile';
import postView from './views/pages/post.js';
import marketplaceView from './views/pages/marketplace.js';
import friendsView from './views/pages/friends.js';
import messagesView from './views/pages/messages.js';
import createEvent from './views/pages/createEvent.js';
import discoverEvents from './views/pages/discoverEvents.js';
import eventView from './views/pages/event.js';

// Create a routes object to map paths to views
const routes = {
  '/': homeView,
  404: fourOFourView,
  '/feed': feedView,
  '/signin': signinView,
  '/signup': signupView,
  '/profile': profileView,
  '/editProfile': editProfileView,
  '/post': postView,
  '/marketplace': marketplaceView,
  '/friends': friendsView,
  '/messages': messagesView,
  '/createEvent': createEvent,
  '/discoverEvents': discoverEvents,
  '/event': eventView,
};

// The Router class is responsible for managing the application's routes
// It initializes the routes and handles navigation between them.
class Router {
  constructor() {
    this.routes = routes;
  }

  // The init method sets up the initial route and adds an event listener for popstate events
  init() {
    this.route(window.location.pathname);

    window.addEventListener('popstate', () => {
      this.route(window.location.pathname);
    });
  }

  // The route method checks if the current pathname matches a route
  route(fullPathname) {
    const pathname = fullPathname.split('?')[0];
    const route = this.routes[pathname];

    if (route) {
      this.routes[window.location.pathname].init();
    } else {
      this.routes['404'].init();
    }
  }

  // The gotoRoute method updates the browser's history and calls the route method
  // to render the new route
  gotoRoute(pathname) {
    window.history.pushState({}, pathname, window.location.origin + pathname);
    this.route(pathname);
  }
}

const AppRouter = new Router();
export default AppRouter;

export function gotoRoute(pathname) {
  AppRouter.gotoRoute(pathname);
}

export function anchorRoute(e) {
  e.preventDefault();
  const pathname = e.target.closest('a').pathname;
  AppRouter.gotoRoute(pathname);
}
